/**
 * 批量修改计划预算
 */
import { Component, input, output } from '@angular/core';
import {
  BatchUploadConfig,
  BatchUploadModalComponent,
} from '@shared/components/batch-upload-modal/batch-upload-modal.component';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'app-batch-upload-campaign-budget',
  imports: [SharedModule, BatchUploadModalComponent],
  template: `
    <app-batch-upload-modal
      [isVisible]="isVisible()"
      [config]="uploadConfig"
      (isVisibleChange)="isVisibleChange.emit($event)"
      (nzOnOk)="nzOnOk()"
    ></app-batch-upload-modal>
  `,
})
export class BatchUploadCampaignBudgetComponent {
  // 输入属性
  readonly isVisible = input<boolean>(false);

  // 输出事件
  readonly isVisibleChange = output<boolean>();

  // 上传配置
  uploadConfig: BatchUploadConfig = {
    title: '批量修改计划预算',
    templateUrl:
      'https://static-cdn.linkworld.cn/xiaohong/红品智-推广-批量修改计划预算模板_2026-04-01.xlsx',
    type: 12,
    description: '1、下载批量修改计划预算模板，批量填写计划预算信息',
  };

  nzOnOk() {
    // 手动埋点 红品智-工具-批量修改计划预算
    (window as any)?.lwTrackEvent?.add({
      event_id: 300,
      event_code: 'spotlight-tools-uploadUpdateCampaignBudget',
      event_type: 'upload',
    });
  }
}
